import { useQuery } from "@tanstack/react-query";
import { QUERY_KEYS } from "../queryKeys";
import { getNewProductDetails, getNewProductDetailsBySlug } from "@/services/api/newListingApis";

export const useGetNewProductDetails = (id: string) => {
  return useQuery({
    queryKey: [QUERY_KEYS.GETNEWPRODUCTDETAILS, id],
    queryFn: () => getNewProductDetails(id),
  });
};

export const useGetNewProductDetailsBySlug = (slug: string) => {
  return useQuery({
    queryKey: [QUERY_KEYS.GETNEWPRODUCTDETAILSBYSLUG, slug],
    queryFn: () => getNewProductDetailsBySlug(slug),
    enabled: !!slug,
  });
};